var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-menu'),_c('section',{staticStyle:{"flex":"1 0 auto"}},[_c('div',{staticClass:"content-inside"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }